import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useNotice = () => {
  const { t } = useTranslation('mediaStudio');
  const [message, setMessage] = useState(null);

  const run = useCallback(
    async (action, errorKey) => {
      try {
        const result = await action();
        setMessage(null);
        return result;
      } catch {
        setMessage(t(errorKey));
        return undefined;
      }
    },
    [t],
  );

  return { message, show: setMessage, run };
};

export default useNotice;
